import { render, staticRenderFns } from "./PersonalAccessTokens.vue?vue&type=template&id=2d9120fa&scoped=true&"
import script from "./PersonalAccessTokens.vue?vue&type=script&lang=js&"
export * from "./PersonalAccessTokens.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAccessTokens.vue?vue&type=style&index=0&id=2d9120fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9120fa",
  null
  
)

export default component.exports